export default __webpack_public_path__ + "static/media/table-order.e9eecb85.gif";